import type { FC } from "react";

import type { BaseIconProps } from "@/assets/icons/utils";

export const IconSidebarSimpleLeftWideFilled: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22 4H2V20H22V4ZM20.5 5.5V18.5H8.5V5.5H20.5Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22 4H2V20H22V4ZM20.5 5.5V18.5H8.5V5.5H20.5Z"
                        fill="currentColor"
                    />
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M22 4H2V20H22V4ZM20.5 5.5V18.5H8.5V5.5H20.5Z"
                        fill="currentColor"
                    />
                </svg>
            );
    }
};
